var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('v-card',{attrs:{"width":"100%","layout":""}},[_c('v-img',{attrs:{"src":require('../assets/bg.jpg'),"height":"100","aspect-ratio":"2.75"}},[_c('v-card-title',{staticClass:"justify-center"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }